import React, { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getCookie } from "../../../util/cookie/cookies";
import { Main } from "../main/main";
import { SubPage } from "../subPage";
import Footer from "./footer/footer";
import { Header } from "./header/header";
import { EngineModeling } from "../../../components/EngineModeling";

const LayOut = () => {
    const navi = useNavigate()
    const location = useLocation()
    const path = location.pathname.split('/')[1];
    const {secondUrl,thridUrl,product} = useParams()
    const lang = getCookie('HYUNDAILANG')
    useEffect(()=>{
        window.scrollTo(0, 0)
    }, [location.pathname])
    return(
        <>
        <div className={`wrap ${lang}`}>
            <Header/>
            {location.pathname === '/' ? <Main/> : ''}
            {location.pathname === `/about/${secondUrl}`?<SubPage/> : ''}
            {location.pathname === `/liebherr/${secondUrl}`?<SubPage/> : ''}
            {location.pathname === `/hyundai/${secondUrl}`?<SubPage/> : ''}
            {location.pathname === `/hyundai/${secondUrl}/${product}` ? <SubPage/> : ''}
            {location.pathname === `/equipmentStatus` ? <SubPage/> :''}
            {location.pathname === `/prCenter/${secondUrl}` ? <SubPage/> :''}
            {location.pathname === `/prCenter/${secondUrl}/${thridUrl}` ? <SubPage/> :''}
            {location.pathname === `/contact/${secondUrl}` ? <SubPage/> : ''}
            <Footer/>
        </div>
        </>
    )
}

export default LayOut;